export const urlLink = "https://static.raffolux.com/static/website/";
export const socialImgUrlLink = "https://static.raffolux.com/static/website/";